import { render, staticRenderFns } from "./MoreSpecialClientPopup.vue?vue&type=template&id=ff42f846&scoped=true"
import script from "./MoreSpecialClientPopup.vue?vue&type=script&lang=js"
export * from "./MoreSpecialClientPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff42f846",
  null
  
)

export default component.exports